import { Block } from 'baseui/block';
import { ValueDisplay } from '../../../components/ValueDisplay'

import { IAHU_Optimizer } from './types'

export function SmallPanel(props: IAHU_Optimizer) {

    return (
            <Block display='flex' flexDirection='row' alignItems='baseline' justifyContent='center' gridGap='5px'>
                <ValueDisplay value={props.output} dimension={'Pa'} small></ValueDisplay>
            </Block>
    );
}